import { useState, useEffect } from 'react';

export const useLastUpdatedTime = (showTime, lastUpdatedTime, maxTimeDiff = 60) => {
    const [timeDifference, setTimeDifference] = useState('');

    useEffect(() => {
        const formatTimeLeft = () => {
            const currentTime = Date.now();
            const difference = currentTime - lastUpdatedTime;
            // const hours = Math.floor(difference / (1000 * 60 * 60));
            const minutes = Math.floor((difference / 1000) / 60);
            const seconds = maxTimeDiff - Math.floor((difference / 1000) % 60);
            if (minutes === 0) {
                setTimeDifference(`${seconds} s`)
            } else if (seconds === 0) {
                setTimeDifference(`${minutes} m`)
            } else {
                setTimeDifference(`${minutes} m ${seconds} s`)
            }        
        };
        const formatTimeAgo = () => {
            const currentTime = Date.now();
            const difference = currentTime - lastUpdatedTime;
            const hours = Math.floor(difference / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);
            const timeParts = [];
            if (hours > 0) timeParts.push(`${hours} h`);
            if (minutes > 0) timeParts.push(`${minutes} m`);
            if (seconds > 0 || timeParts.length === 0) timeParts.push(`${seconds} s`);
            setTimeDifference(timeParts.join(' '));
        };

        const formatTime = () => {
            setTimeDifference((new Date(Date.now())).toLocaleTimeString())
        }
    
        if (showTime === 'time'){
            formatTime();
        }else if (showTime === 'time-left'){
            formatTimeLeft();
            const intervalId = setInterval(formatTimeLeft, 1000);
            return () => clearInterval(intervalId); 
        }else if (showTime === 'time-ago'){
            formatTimeAgo();
            const intervalId = setInterval(formatTimeAgo, 1000);
            return () => clearInterval(intervalId); 
        }

    }, [lastUpdatedTime, showTime, maxTimeDiff]);

    return (timeDifference);
}

export default useLastUpdatedTime;